export const FIELD_ORIGIN = Object.freeze({ MERGEFIELD: 'MERGEFIELD' });
